const getFirstCollapsedSection = (sectionRefs) => {
  // As we're only interested in the height of the section, this
  // approach ensures we don't accidentally get a collapsing or expanding
  // section.
  return sectionRefs.find((sectionRef) => sectionRef.current.clientHeight < 150);
};

export const getCollapsedSectionHeight = (sectionRefs) => {
  const sectionElement = getFirstCollapsedSection(sectionRefs).current;
  const sectionBottomMarginString = getComputedStyle(sectionElement).getPropertyValue(
    'margin-bottom'
  );
  const sectionBottomMargin = parseInt(sectionBottomMarginString, 10);
  return sectionElement.clientHeight + sectionBottomMargin;
};
